import React from 'react';
import {withNamespaces} from "react-i18next";
import {Spinner} from "react-bootstrap";

const SelectFilter = ({ t, column: {filterValue, setFilter, filterOptions}}) => {

    return (
            <select
                className="form-control"
                value={filterValue}
                placeholder={t('column-find')}
                onChange={e => {
                    setFilter(e.target.value || undefined)
                }}
            >
                <option value={''}> {null} </option>
                { filterOptions.map((item, idx) => {
                    if(item) {
                        return (
                            <option key={idx} value={item}>{ item }</option>
                        );
                    }
                }) }
            </select>

    )
};
export default withNamespaces()(SelectFilter);
